// src/constants.js
export const DEFAULT_BPM = 60;